import Enumerable from "linq";
import * as sonbpIfconst from "../../sonbpIf/base/constants";
import * as idbEdit from "../../entity/idb/editInfo";
import * as es6promise from "es6-promise";
import { Logger } from "../../util/logger";
import { response, util } from "../..";
import { constDialogMessage, dialogUtil } from "../../util";
import { calcCheckSum, editStrage } from "../edit.tool";

import * as edconst from "../edit.const";
import { EditConst } from "../edit.const";
import { UploadImageResponseEntity, uploadPhoto } from "../edit.entity";
import { itemVenderProperty } from "../edit.sonbp_if";
import { UploadImageLogicClass } from "./edit.uploadImageLogic.base";

// from FontGenic
declare var fontgenicSdkCreate: any;
declare var fontgenicSdkInit: any;


/**
 * 手書きスタンプ
 * 画像アップロード、画像配置の処理を提供するクラス
 */
export class TegakiStampLogicClass extends UploadImageLogicClass {

// #region ■定数

    /**
     * 手書きスタンプ画像最大数
     * @override
     */
    protected readonly UPLOAD_IMAGE_NUM_MAX: number = 50;

    /**
     * スタンプ配置可能な数
     * @override
     */
    protected readonly PUT_MAX: number = 50;

    /**
     * 手書きスタンプアップロード(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_UPLOADIMAGE: string = "Edit/UploadTegakiStamp";
    /**
     * 手書きスタンプ画像サムネイル取得(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_GETTHUMBNAIL: string = "Edit/GetTegakiStampThumb";
    /**
     * 手書きスタンプ画像色替え(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_CHANGETEGAKICOLOR: string = "Edit/ChangeTegakiStampColor";

    protected readonly VIEW_TITLE: string = EditConst.TITLE_TEGAKISTAMP;
    protected readonly VIEW_MODE: string = edconst.EDIT_MODE_KIND.FONTGENIC;
    protected readonly VIEW_ITEM_TYPE: string = sonbpIfconst.ITYPE_FONTGENIC_IMG;

// #endregion

// #region ■プロパティ

    /**
     * アップロード画像最大数(手書きスタンプ用)
     * @implements
     */
    public UploadNumMax(): number {
        return this.UPLOAD_IMAGE_NUM_MAX;
    }

// #endregion

// #region ■イベント

    /**
     * ツールメニュー：スタンプ押下メソッド
     * @summary 編集モードをスタンプにして画面表示を切り替える。
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * @implements
     */
    public btnClickStampMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        if (this._edctrl.editMode === edconst.EDIT_MODE_KIND.FONTGENIC) {
            return;
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(edconst.EDIT_MODE_KIND.FONTGENIC,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = edconst.EDIT_MODE_KIND.FONTGENIC;

                this.setShowFlgAllOFF();

                if (this._usePcDesign) {
                    // PC用
                    // パネルの表示制御
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.TegakiStampPanel = true;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveTegakiStampMenu = true;

                    // フェードインアウトの初期化
                    this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
                    this._vue.$data.TegakiStamp.fade.In = false;
                    this._vue.$data.TegakiStamp.fade.Out = false;

                    // オブジェクト操作パレットの制御
                    this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.FONTGENIC, null);

                    // 選択アイテムの指定
                    this.sonbpIfController.getTegakiStampList(
                        (list: itemVenderProperty[]) => {
                            if (0 < list.length) {
                                this._vue.$data.Show.OparatePalletCover = false;

                                const idx = selectedItemVp?.idx ?? list[0].idx;
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_FONTGENIC_IMG, idx,
                                    () => { Logger.debug("選択アイテムの指定 成功"); },
                                    () => {
                                        Logger.error("選択アイテムの指定 失敗");
                                        this._vue.$data.Show.OparatePalletCover = true;
                                    });
                            }
                            else {
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                        }
                    );
                }
                else {
                    // SP用

                    // パネルの表示制御
                    this._vue.$data.Show.EditArea = true;
                    this._vue.$data.Show.FooterMenu = true;

                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    this.sonbpIfController.getTegakiStampList((list: itemVenderProperty[]) => {
                        // 作成済みのスタンプが存在するか判定
                        if (0 < list.length) {
                            // 存在する場合、スタンプの位置調整表示
                            this._vue.$data.Header.Title = EditConst.TITLE_TEGAKISTAMP;
                            this._vue.$data.Show.ReturnHomeExBtn = true;
                            this._vue.$data.Show.CommitNextHomeBtn = true;

                            this._vue.$data.Stamp.DelBtnEnable = false;
                            this._vue.$data.EnableUploadListTrashOK = false;

                            // オブジェクト操作パレットの表示制御
                            this._vue.$data.Show.OparatePallet = true;
                            this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.FONTGENIC, null);

                            // タッチイベント制御(無効)
                            this._edctrl.touchEventChange(false);

                            // 選択アイテムの指定
                            this._vue.$data.Show.OparatePalletCover = false;
                            const idx = selectedItemVp?.idx ?? list[0].idx;
                            this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_FONTGENIC_IMG, idx,
                                () => {
                                    Logger.debug("選択アイテムの指定 成功");
                                    this._vue.$data.Stamp.DelBtnEnable = true;
                                },
                                () => {
                                    Logger.error("選択アイテムの指定 失敗");
                                    this._vue.$data.Show.OparatePalletCover = true;
                                });
                        }
                        else {
                            // 存在しない場合、スタンプの編集表示
                            this.setStampEditMode();
                        }
                    });
                }
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
     * 手書きスタンプファイル選択押下メソッド
     * @summary 手順ダイアログ表示してからFontGenicを呼び出す。
     */
    public async btnClickUploadTegakiStamp(event: any) {

        let that = this;

        new es6promise.Promise((res, rej) => {

            //「次回は表示しない」がチェックされたらダイアログ表示しない。
            if (that._vue.$data.ConfirmTegakiStampCheckbox) {
                res(true);
                return;
            }

            // ダイアログ表示
            dialogUtil.showTegakiStampHowToDlg(that._usePcDesign)
                .then(function (ret) {
                    that._vue.$data.ConfirmTegakiStampCheckbox = ret.chk
                    res(ret.btn);
                })
                .catch(function (err) {
                    rej(err);
                });

        }).then(function (btn) {

            if (btn != true) {
                //キャンセルならおしまい
                return;
            }

            // ローディングダイアログ開始
            util.dialogUtil.showLoading();

            // アップロードファイルの最大数チェック
            if (that.UploadNumMax() <= that.NotEmptyUploadNum) {
                // メッセージ表示
                util.dialogUtil.createErrorDialog(util.constDialogMessage.ERROR_IMAGE_UPLOAD_OVER_MAX_TEXT
                    , () => {
                        dialogUtil.closeErrorDialog();
                        util.dialogUtil.closeLoading();
                    },
                    dialogUtil.DialogType.Warning
                );
                return;
            }

            //fontgenic連携開始
            that.fontgenicStart();
        });
    }

    // #region ■イベント（PCのみ処理）

    /**
     * 手書きスタンプ色選択押下メソッド
     * @summary 選択された色でCanvasの配置画像を置換える。
     */
    public radioClickTegakiColorPc(colorId: string, event: JQueryEventObject): void {

        this.changeTegakiStampColor(colorId);
    }

    // #endregion

    // #region ■イベント（SPのみ処理）

    /**
     * 操作パネル→手書きスタンプ色変更ボタン押下メソッド(SP用)
     * @summary 色変更画面を表示する。
     */
    public btnClickChangeTegakiStampColorSp(event: JQueryEventObject): void {

        // タッチイベント制御(有効)
        this._edctrl.touchEventChange(true);

        // パネルの表示制御
        this.setShowFlgAllOFF();
        this._vue.$data.Header.Title = EditConst.TITLE_TEGAKISTAMP_COLOR;
        this._vue.$data.Show.TegakiColorPanel = true;
        this._vue.$data.Show.ReturnTegakiStampHomeBtn = true;

        //現在の色を選択状態にしておく
        this._vue.$data.SelectTegakiColorSPEdit = this._vue.$data.SelectTegakiColor;
    }

    /**
     * (手書き色選択パネルから)次へボタン押下メソッド(SP)
     * @summary 選択された色でCanvasの配置画像を置換える。置換後、位置調整画面を表示する。
     */
    public btnClickNextHomeFromTegakiColorPanelSp(event: JQueryEventObject): void {

        let that = this;
        this.changeTegakiStampColor(this._vue.$data.SelectTegakiColorSPEdit)
            .then((isSuccess) => {
                if (isSuccess) {
                    this._vue.$data.SelectTegakiColor = this._vue.$data.SelectTegakiColorSPEdit;
                    that.returnStampHomeBtn(null);
                }
            });
    }

    // #endregion

// #endregion

// #region ■内部関数

    /**
     * 手書きスタンプ編集モードへ画面項目設定(SP用)
     * @summary アップロード画像一覧画面を表示する。
     * @implements
     */
    public setStampEditMode() {

        // パネルの表示制御
        this.setShowFlgAllOFF();
        this._vue.$data.Header.Title = EditConst.TITLE_IMAGELIST;
        this._vue.$data.Show.TegakiStampList = true;
        this._vue.$data.Show.ReturnTegakiStampHomeBtn = true;
        this._vue.$data.Show.NextHomeFromTegakiStampListBtn = true;
        this._vue.$data.Show.TegakiStampListTrashBtn = true;

        // 選択状態をクリア
        this._uploadImageList.forEach(row => row.selected = EditConst.IMG_NOSELECT);

        // 削除(＆次へ)ボタンの活性制御
        this._vue.$data.EnableUploadListTrashOK = false;
    }

    /**
     * 引き剥がし対象のIDを抽出
     * @summary アップロード一覧から画像削除される際、Canvasに配置済みならそのfileIdを抽出する。
     * @override
     */
    protected getRemoveTargetIds(): string[] {

        let removeIds: string[] = [];
        let useItems: itemVenderProperty[] = [];

        // 配置済の画像取得
        this.sonbpIfController.getTegakiStampList(
            (list: itemVenderProperty[]) => {
                useItems = list;
            });

        // 削除対象の画像IDを抽出
        let delListIds = Enumerable.from(this._uploadImageList)
            .where(row => row.reqDelete === true)
            .select(row => row.fileId);
        removeIds = Enumerable.from(useItems)
            .where(row => delListIds.indexOf(row.file_id.split('@')[0]) >= 0)
            .select(row => row.file_id).distinct().toArray();

        return removeIds;
    }

    /**
     * 手書きスタンプ削除依頼処理
     * @summary 一覧から選択画像を削除し、Canvasに配置済ならその配置も引きはがす。
     * @implements
     */
    public requestRemove(fileIds: string[]) {

        this.sonbpIfController.removeTegakiStampById(fileIds,
            () => {
                Logger.debug("手書きスタンプ削除依頼処理 正常終了");
                // 正常終了の場合
                this.afterRemove();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_DEL_TEGAKISTAMP, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
     * 手書きスタンプ削除後の処理
     * @summary 一覧の削除枠を詰めて空き枠を整理する。
     * @override
     */
    protected afterRemove() {

        super.afterRemove();

        // 残スタンプを確認
        this.sonbpIfController.getTegakiStampList((stampList: itemVenderProperty[]) => {
            if (stampList.length === 0) {
                // ０件の場合
                this._vue.$data.Stamp.DelBtnEnable = false;
                this._vue.$data.Show.OparatePalletCover = true;

                this._vue.$data.SelectTegakiColor = "";
            }
            else {
                // 上記以外の場合
                let leftStamp: boolean = true;
                this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_FONTGENIC_IMG, () => { }, () => { leftStamp = false }, () => { leftStamp = false });
                if (leftStamp) {
                    this._vue.$data.Stamp.DelBtnEnable = true;
                } else {
                    this._vue.$data.Stamp.DelBtnEnable = false;
                    this._vue.$data.Show.OparatePalletCover = true;
                }
            }
        });
    }

    /**
     * 手書きスタンプ画像設定処理(本体) 
     * @summary 選択された画像をCanvasへ配置する（実際の処理）
     * @implements
     */
    public setImageBody(fileId: string, targetPhoto: uploadPhoto, nextFun: () => void) {
        Logger.debug("手書きスタンプ画像押下メソッド fileId[" + fileId + "]");

        let that = this;
        this.commonSetStampBody(fileId, targetPhoto, () => {
            if (nextFun)
                nextFun();
        });
    }

    /**
     * 手書きスタンプ色変更
     * @summary サーバAPIを呼んで指定色のスタンプ画像生成を行う。
     */
    private changeTegakiStampColor(colorId: string): es6promise.Promise<boolean> {
        console.log("手書きスタンプ色変更", colorId);

        let that = this;
        return new es6promise.Promise(function (resolve, reject) {

            //選択中のアイテム
            let selItem = that.sonbpIfController.getSelectItem();

            if (!selItem) {
                Logger.debug("アイテムが選択されていません");
                resolve(false);
                return;
            }

            // ローディングダイアログ開始
            util.dialogUtil.showLoading();

            let pureFileId = selItem.file_id.split('@')[0];

            that.uploadTegakiStampChangeColor(pureFileId, colorId).then((resData: response.responseEntity) => {

                return new es6promise.Promise((res, rej) => {

                    //sonbpへ依頼
                    let idx = Number(selItem.idx);
                    let fileIdWidthAtmark = pureFileId + '@' + colorId;
                    that.sonbpIfController.setTegakiStamp(idx, fileIdWidthAtmark, 0, 0, res, rej);  //画像差替えはサイズ無視なのでw,h=0
                });

            }).then(() => {

                // 正常終了の場合
                util.dialogUtil.closeLoading();
                resolve(true);
            }).catch((err: any) => {

                // 上記以外の場合
                util.dialogUtil.closeLoading();
                util.dialogUtil.createErrorDialog(
                    constDialogMessage.ERROR_EDIT_CHANGE_TEGAKISTAMP,
                    () => {
                        util.dialogUtil.closeErrorDialog();
                    }
                );
                reject();
            });
        });
    }

    /**
     * 一覧をidbへ保存
     * @summary アップロード一覧情報をidbへ保存する
     * @implements
     */
    public writeStorage(list: idbEdit.photo[]): boolean {

        return editStrage.writeStorageToTegakiStamp(list);
    }

    /**
     * スタンプ配置
     * @summary SonbpIfへスタンプ配置を依頼する。
     * @implements
     */
    public callSonbpIfSetStamp(idx: number, target: uploadPhoto, okFunc: () => void, errFunc: () => void): void {

        let fileIdWidthAtmark = target.fileId + "@0";
        this.sonbpIfController.setTegakiStamp(idx, fileIdWidthAtmark, target.width, target.height, okFunc, errFunc);
    }


    // #region ■ファイルアップロード関連

    /**
     * 有効なアップロードファイルであるかのチェック
     * @summary ファイルのサイズ・MIMEチェックを行う。
     * @implements
     */
    public uploadFileValid(file: File): string {
        // ファイルチェックはFontGenicにおまかせ。
        return "";
    }

    /**
     * fontgenic連携呼出し
     * @summary iframeでfontgenicを呼出し、コールバックを待つ。
     */
    private fontgenicStart() {
        console.log("gontgenic call start.")

        //IFrame準備
        if (!($("#fontgenicIframePanel").length)) {
            let fgblock =
                '<div id="fontgenicIframePanel" class="fontgenicIframePanel is-hidden" >\
<iframe id="fontgenicIframe" class="fontgenicIframeArea" name="fontgenicIframe" frameborder="0" allow="fullscreen" class="fontgenicIframeArea" >\
</iframe>\
</div>'
            $('body').append($(fgblock));
        }

        $("#fontgenicIframePanel").removeClass("is-hidden");
        if (this._usePcDesign) this._vue.$data.Show.IsShowIframePanel = true;

        //fontgenic呼出し
        let that = this;
        fontgenicSdkInit("fontgenicIframe",
            (blob: Blob) => {
                //OK
                console.log("gontgenic callback OK.")
                //$("#fontgenicIframePanel").addClass("is-hidden");
                $("#fontgenicIframePanel").remove();
                if (this._usePcDesign) this._vue.$data.Show.IsShowIframePanel = false;

                let reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async () => {

                    let base64String = reader.result as string;
                    that.fontgenicCallbackAfter(base64String);
                };
            },
            (message) => {
                //キャンセル
                console.log("gontgenic callback Cancel.", message);
                //$("#fontgenicIframePanel").addClass("is-hidden");
                $("#fontgenicIframePanel").remove();
                util.dialogUtil.closeLoading();
                if (this._usePcDesign) this._vue.$data.Show.IsShowIframePanel = false;
            }
        );
        fontgenicSdkCreate('0', 'ja');
    }

    /**
     * FontGenicのコールバック後の処理
     * @summary fontgenicから渡された画像(base64)をサーバへアップロードする。
     */
    private fontgenicCallbackAfter(base64: string) {

        //チェック不要（妥当性はfontgenicにおまかせ）

        //純なbase64にしておく
        let top = base64.indexOf(';base64,') + 8;
        base64 = base64.substring(top);

        // アップロード処理へ
        this.uploadTegakiStampCover(base64).then((fileId: string) => {

            Logger.debug("アップロード完了", fileId);

            // ローディングダイアログ終了
            util.dialogUtil.closeLoading();

        }).catch((err) => {

            util.dialogUtil.closeLoading();
            const msg: string = util.constDialogMessage.ERROR_EDIT_CREATE_TEGAKISTAMP + "<br>";
            util.dialogUtil.createErrorDialog(msg, () => {
                dialogUtil.closeErrorDialog();
            }, dialogUtil.DialogType.Warning);
        });
    }

    /**
     * アップロード処理入口
     * @summary MD5を生成する。アップロード成功したらサムネイル画像の取得を行う。
     * @summary Myスタンプとは送信Form形式ちがうため共通化できず、別途実装としている。
     */
    private uploadTegakiStampCover(base64: string): es6promise.Promise<any> {

        const that = this;

        return new es6promise.Promise(async function (resolve, reject) {

            //MD5取得のため、一旦base64->file変換する
            let file: File;
            {
                let bin = atob(base64.replace(/^.*,/, ''));
                // バイナリデータ化
                let buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                    buffer[i] = bin.charCodeAt(i);
                }
                // ファイルオブジェクト生成
                file = new File([buffer.buffer], "fontgenic.png", { type: "image/png" });
            }

            //ファイルは１件なのでuploadTegakiStampBodyはここに包含する

            // MD5算出
            calcCheckSum(file).then((md5: string) => {

                Logger.debug("MD5 [" + md5 + "]");

                // アップロード実行
                that.uploadTegakiStamp(base64, md5).then((resData: response.responseEntity) => {
                    if (resData.result.code === 0) {
                        // 正常
                        const photoEntity: UploadImageResponseEntity = resData.data;
                        photoEntity.fileObject = file;
                        resolve(photoEntity);
                    }
                    else {
                        reject("code:" + resData.result.code + ",msg:" + resData.result.message);
                    }
                }).catch((err: any) => {
                    reject(err);
                });
            }).catch((err: Error) => {
                Logger.error(err);
                reject(err);
            });

        }).then((uploadResult: UploadImageResponseEntity) => {

            // アップロード画像のサムネイル取得
            return that.getThumbnail(uploadResult.fileId, uploadResult.width, uploadResult.height, null);

        }).then((fileId: string) => {

            Logger.debug("アップロードファイル情報 iDBへ書き込み 開始");

            return new es6promise.Promise(async function (resolve, reject) {

                const setTegakiStampList: idbEdit.uploadStampUseInfo[] = [];

                // indexedDBの手書きスタンプ情報更新
                that.setSaveUploadInfo(that._uploadImageList, setTegakiStampList);

                if (editStrage.writeStorageToTegakiStamp(setTegakiStampList)) {
                    Logger.debug("手書きアップロードファイル情報 WebStorageへ書き込み 正常終了", fileId);
                    resolve(fileId);
                }
                else {
                    Logger.error("手書きアップロードファイル情報 WebStorageへ書き込み エラー終了", fileId);
                    reject(fileId);
                }
            });
        });
    }

    /**
     * 手書きスタンプアップロードリクエスト
     * @summary Formデータを組み立ててサーバAPIへリクエスト実施。
     */
    private uploadTegakiStamp(base64: string, md5: string): es6promise.Promise<response.responseEntity> {

        // パラメータ
        let fd: FormData = new FormData();
        fd.append("token", this._authToken);
        fd.append("MD5", md5);
        fd.append("fontGenic64", base64);

        return this.commonUploadImageFileSend(this.WEBAPI_URL_UPLOADIMAGE, fd, "no_name");
    }

    /**
     * 手書きスタンプ色変更リクエスト
     * @summary サーバAPIへリクエスト実施。
     */
    private uploadTegakiStampChangeColor(fileId: string, colorId: string): es6promise.Promise<response.responseEntity> {

        const req = {
            token: this._authToken,
            colorId: colorId,
            fileId: fileId
        }

        return util.ajax.post(this.WEBAPI_URL_CHANGETEGAKICOLOR, JSON.stringify(req));
    }

    // #endregion

// #endregion

}
